import styled, { css } from 'styled-components'
import { rem } from 'utils/common'
import { device, fonts, merchantThemes } from 'components/Variable'
import Popup from 'reactjs-popup'

export const ShippingPopup = styled(Popup)`
	// use your custom style for ".popup-overlay"
	&-overlay {
	}
	// use your custom style for ".popup-content"
	&-content {
		padding: 0;
		border-radius: ${rem(8)};
		width: 95%;
		max-width: ${rem(800)};

		@media (${device.tablet}) {
			max-width: ${rem(600)};
		}
		@media (${device.mobileM}) {
			max-width: none;
		}
	}
`

const sharedCSS = css`
	font-family: ${fonts.openSans};
	font-style: normal;
	font-weight: 600;
	font-size: ${rem(14)};
	line-height: ${rem(19)};
	letter-spacing: ${rem(0.2)};

	${(p) =>
		p.theme.name === merchantThemes.woodwood &&
		css`
			font-family: ${fonts.WWBeta8Regular};
		`}

	${(p) =>
		p.theme.name === merchantThemes.hh &&
		css`
			font-family: ${fonts.dinPro};
		`}
	 
    ${(p) =>
		p.theme.name === merchantThemes.marysia &&
		css`
			font-family: ${fonts.futura};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes['8848'] &&
		css`
			font-family: ${fonts.futura};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.aycane &&
		css`
			font-family: ${fonts.IBMPlex};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.bymalina &&
		css`
			font-family: ${fonts.Avenir};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.henrylloyd &&
		css`
			font-family: ${fonts.Gotham};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.chimi &&
		css`
			font-family: ${fonts.AmericaExpandedRegular};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.ogoship &&
		css`
			font-family: ${fonts.usual};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			font-family: ${fonts.MonumentGrotesk};
			font-size: ${rem(15)};
			line-height: ${rem(20)};
			letter-spacing: ${rem(0.06)};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.sns &&
		css`
			font-family: ${fonts.AktivGroteskEx};
		`}
`

export const ShipmentBlock = styled.div`
	background: ${({ theme }) => theme.color.secondary};
	box-shadow: inset 0 0 ${rem(1)} ${rem(1)}
		${({ theme }) => theme.color.grayTwelve};
	border-radius: ${rem(8)};
	position: relative;
	padding: ${rem(31, 32)};
	max-width: ${rem(956)};
	margin: ${rem(10)} auto;
	cursor: pointer;
	overflow: hidden;
	z-index: 0;

	@media (${device.tablet}) {
		//padding: ${rem(28, 12)};
	}

	${(p) =>
		p.isActive &&
		css`
			box-shadow: inset 0 0 ${rem(1)} ${rem(2)}
				${({ theme }) => theme.color.primary};
		`}
`
export const ShipmentInnerBlock = styled.div`
	display: flex;
	position: relative;
	align-items: center;
	justify-content: space-between;
`

export const ShipmentTitle = styled.div`
	${sharedCSS};
	color: ${({ theme }) => theme.color.blackOne};
	margin: 0 0 ${rem(2)} 0;

	@media (${device.tablet}) {
		display: none;
	}

	@media (${device.mobileM}) {
		font-size: ${rem(12)};
	}
`

export const ShipmentMobileTitle = styled.div`
	${sharedCSS};
	display: none;
	position: relative;
	top: ${rem(-8)};

	@media (${device.tablet}) {
		display: block;
	}
`
export const ShipmentDescription = styled.div`
	${sharedCSS};
	font-size: ${rem(12)};
	font-style: italic;
	color: ${({ theme }) => theme.color.blackOne};

	@media (${device.tablet}) {
		max-width: ${rem(350)};
		font-size: ${rem(10)};
	}

	@media (${device.mobileM}) {
		display: none;
	}
`
export const ShipmentCost = styled.div`
	${sharedCSS};
	margin: 0 0 ${rem(2)} 0;
`

export const ShipmentRadio = styled.div`
	font-family: ${fonts.openSans};
	font-style: normal;
	font-weight: normal;
	font-size: ${rem(16)};
	line-height: ${rem(18)};
	color: ${({ theme }) => theme.color.blackOne};
	padding: ${rem(6, 0, 6, 35)};
	position: relative;

	${(p) =>
		p.theme.name === merchantThemes.woodwood &&
		css`
			font-family: ${fonts.WWBeta8Regular};
		`}

	${(p) =>
		p.theme.name === merchantThemes.hh &&
		css`
			font-family: ${fonts.dinPro};
		`}
	 
    ${(p) =>
		p.theme.name === merchantThemes.marysia &&
		css`
			font-family: ${fonts.futura};
		`}
	${(p) =>
		p.theme.name === merchantThemes['8848'] &&
		css`
			font-family: ${fonts.futura};
		`}
		${(p) =>
		p.theme.name === merchantThemes.aycane &&
		css`
			font-family: ${fonts.IBMPlex};
		`}
		${(p) =>
		p.theme.name === merchantThemes.bymalina &&
		css`
			font-family: ${fonts.Avenir};
		`}
		${(p) =>
		p.theme.name === merchantThemes.henrylloyd &&
		css`
			font-family: ${fonts.Gotham};
		`}
		${(p) =>
		p.theme.name === merchantThemes.chimi &&
		css`
			font-family: ${fonts.AmericaExpandedRegular};
		`}
		${(p) =>
		p.theme.name === merchantThemes.ogoship &&
		css`
			font-family: ${fonts.usual};
		`}
		${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			font-family: ${fonts.MonumentGrotesk};
			font-weight: normal;
		`}
		${(p) =>
		p.theme.name === merchantThemes.sns &&
		css`
			font-family: ${fonts.AktivGroteskEx};
		`}

	&:after,
	&:before {
		position: absolute;
		content: '';
		left: 0;
		width: ${rem(20)};
		height: ${rem(20)};
		border: ${rem(1)} solid ${({ theme }) => theme.color.blackOne};
		border-radius: 50%;
		top: 50%;
		margin-top: ${rem(-10)};
	}

	&:after {
		width: ${rem(12)};
		height: ${rem(12)};
		background: ${({ theme }) => theme.color.primary};
		border: none;
		display: none;
		margin-top: ${rem(-6)};
		left: ${rem(4)};
	}

	&:hover {
		font-weight: 600;
	}

	${(p) =>
		p.isActive &&
		css`
			font-weight: 600;
			&:after {
				display: block;
			}
			&:before {
				border: ${rem(1)} solid ${({ theme }) => theme.color.primary};
			}
		`}
`

export const ShipmentImgHolder = styled.div`
	padding: ${rem(0, 32)};

	@media (${device.tablet}) {
		padding: ${rem(0, 5)};
		width: ${rem(75)};

		& > img {
			display: block;
			width: 100%;
			min-width: ${rem(48)};
		}
	}

	@media (${device.mobileM}) {
		padding: 0;
		width: ${rem(100)};

		& > img {
			display: block;
			width: 100%;
			min-width: ${rem(30)};
		}
	}

	@media (${device.mobileS}) {
		padding: 0;
		width: ${rem(100)};

		& > img {
			display: block;
			width: 100%;
			min-width: ${rem(25)};
		}
	}
`

export const ShipmentInfoTooltip = styled.div`
	flex: 0 0 ${rem(35)};
	max-width: ${rem(35)};
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	svg {
		fill: ${({ theme }) => theme.color.blackTwo};
	}
	&:hover svg {
		fill: ${({ theme }) => theme.color.blackOne};
	}

	& .shipment_info_icon {
		max-width: ${rem(250)};
	}

	@media (${device.mobileXL}) {
		display: none;
	}
`

export const ShipmentSetLabels = styled.div`
	position: relative;
	background: ${({ theme }) => theme.color.secondary};
	border-radius: ${rem(8)};
	display: none;
	z-index: 1;
	${(p) =>
		p.isVisible &&
		css`
			display: block;
		`}
`

export const ShipmentSetLabelsSelectorDescription = styled.div`
	font-size: ${rem(14)};
	text-align: center;
`

export const ShipmentSetLabelsSelector = styled.div``

export const ShipmentOptionsCount = styled.div`
	font-size: ${rem(12)};
	font-weight: 900;
	color: ${({ theme }) => theme.color.blackOne};
	margin: ${rem(10)} 0 0 0;
`

export const ShipmentOptionsCountNumber = styled.span`
	text-decoration: underline;
`

export const ShipmentSetLabelsSelectorList = styled.ul`
	display: inline-block;
	list-style-type: none;
	justify-content: center;
	margin-top: ${rem(10)};
	min-height: ${rem(80)};
	padding: 0 ${rem(5)};
	flex-wrap: wrap;
`

export const ShipmentSetLabelsSelectorListItem = styled.li`
	cursor: pointer;
	text-transform: capitalize;
	margin: 0 ${rem(10)};
	position: relative;
	padding: ${rem(5)} 0 ${rem(5)} ${rem(20)};
	font-weight: normal;
	text-align: left;

	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			text-transform: none;
		`}

	@media (${device.tablet}) {
		font-size: ${rem(14)};
	}

	@media (${device.mobileM}) {
		font-size: ${rem(14)};
	}

	&:after,
	&:before {
		position: absolute;
		content: '';
		left: ${rem(-5)};
		width: ${rem(20)};
		height: ${rem(20)};
		border: ${rem(1)} solid ${({ theme }) => theme.color.blackOne};
		border-radius: 50%;
		top: 50%;
		margin-top: ${rem(-10)};
	}

	&:after {
		width: ${rem(12)};
		height: ${rem(12)};
		background: ${({ theme }) => theme.color.primary};
		border: none;
		display: none;
		margin-top: ${rem(-6)};
		left: ${rem(-1)};
	}

	&:hover {
		font-weight: 600;
	}

	${(p) =>
		p.isActive &&
		css`
			text-decoration: underline;
			&:after {
				display: block;
			}
		`}
`

export const ShipmentMainBody = styled.div`
	flex: 1 0;
	@media (${device.mobileM}) {
		flex-basis: ${rem(183)};
	}
`
